export default "__VITE_ASSET__11838da0__"